import React, { useState } from 'react';
import classNames from 'classnames';

import { Modal } from '@testsigma/atoms';

import { useSFConnectionState } from '@contexts/sf-connection-context';

import {
  LinkedEntitiesConnectionScreen,
  DeleteConnectionScreen,
  LinkedEntitiesLoadingScreen,
} from '../components/delete-connection-modal-screens';

import { useFetchLinkedEntities } from '../hooks';

export type DeleteScreenModeType = 'loading' | 'linked-entities' | 'delete';

const DeleteConnectionModal: React.FC = () => {
  const { showDeleteModal } = useSFConnectionState();
  const [screenMode, setScreenMode] = useState<DeleteScreenModeType>('loading');

  const handleUpdateScreenMode = (screenModeValue: DeleteScreenModeType) => {
    setScreenMode(screenModeValue);
  };

  const { linkedTestCases, linkedStepGroups, reload, handleCancel } =
    useFetchLinkedEntities({
      handleUpdateScreenMode,
    });

  if (showDeleteModal === false) {
    return null;
  }

  return (
    <Modal
      className={classNames('!rounded-xl !p-6 w-125 !relative')}
      closeOnEscape={false}
      closeOnOutsideClick={false}>
      {screenMode === 'loading' && <LinkedEntitiesLoadingScreen />}

      {screenMode === 'linked-entities' && (
        <LinkedEntitiesConnectionScreen
          linkedTestCases={linkedTestCases}
          linkedStepGroups={linkedStepGroups}
          handleCancel={handleCancel}
          reload={reload}
        />
      )}

      {screenMode === 'delete' && <DeleteConnectionScreen />}
    </Modal>
  );
};

export { DeleteConnectionModal };
